(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref400"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref400"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gBmLA", function(module, exports) {
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("9Wvn0", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("cqYiL")).then(function() {
    return parcelRequire('iTZ5P');
});

});
parcelRegister("hCcZp", function(module, exports) {
"use strict";

var $LG50i = parcelRequire("LG50i");
module.exports = $LG50i(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("LG50i", function(module, exports) {
"use strict";
var $08f5080dd19acb17$var$cachedBundles = {};
var $08f5080dd19acb17$var$cachedPreloads = {};
var $08f5080dd19acb17$var$cachedPrefetches = {};
function $08f5080dd19acb17$var$getCache(type) {
    switch(type){
        case 'preload':
            return $08f5080dd19acb17$var$cachedPreloads;
        case 'prefetch':
            return $08f5080dd19acb17$var$cachedPrefetches;
        default:
            return $08f5080dd19acb17$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $08f5080dd19acb17$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("5TUQh", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("hoSNJ")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("5An4N"))
]).then(function() {
    return parcelRequire('51wCY');
});

});
parcelRegister("jTFkX", function(module, exports) {
"use strict";

var $LG50i = parcelRequire("LG50i");
module.exports = $LG50i(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("97pEG", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("8xFqm")).then(function() {
    return parcelRequire('3ZHAa');
});

});

parcelRegister("99uCv", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("7JefW")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("j8ywC"))
]).then(function() {
    return parcelRequire('9XPWH');
});

});

parcelRegister("3wkHv", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("5GTpR")).then(function() {
    return parcelRequire('d6xO8');
});

});

parcelRegister("lRD4C", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("gZsuc")).then(function() {
    return parcelRequire('53egZ');
});

});

parcelRegister("4MthR", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("etSDY")).then(function() {
    return parcelRequire('WY081');
});

});

parcelRegister("eDuNa", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("3HgTV")).then(function() {
    return parcelRequire('dQcqH');
});

});

parcelRegister("6D3tK", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("kaBKd")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("4sX1A"))
]).then(function() {
    return parcelRequire('hVP1j');
});

});

parcelRegister("aw1e4", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("3wgN9")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("eFnYd"))
]).then(function() {
    return parcelRequire('4i3nO');
});

});

parcelRegister("hwV6k", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("gnvdu")).then(function() {
    return parcelRequire('9Q2vk');
});

});

parcelRegister("eysPy", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("iAlPo")).then(function() {
    return parcelRequire('3e5er');
});

});

parcelRegister("lY8wQ", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("loWJC")).then(function() {
    return parcelRequire('9asrW');
});

});

parcelRegister("5NvQQ", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("9tiVx")).then(function() {
    return parcelRequire('464FV');
});

});

parcelRegister("aga3L", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("jhsKi")).then(function() {
    return parcelRequire('5toZu');
});

});

parcelRegister("6AmCE", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("30o7y")).then(function() {
    return parcelRequire('3hMvC');
});

});

parcelRegister("jvLL0", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("26zBb")).then(function() {
    return parcelRequire('ab8uU');
});

});

parcelRegister("gYu3a", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("2g9s5")).then(function() {
    return parcelRequire('jIj6p');
});

});

parcelRegister("42APl", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("j4I4v")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("gtSJU"))
]).then(function() {
    return parcelRequire('4Eb7c');
});

});

parcelRegister("7Ri5d", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("jTFkX"))($parcel$resolve("futxT")),
    (parcelRequire("hCcZp"))($parcel$resolve("ixT6m")),
    (parcelRequire("hCcZp"))($parcel$resolve("9Ca07"))
]).then(function() {
    return parcelRequire('e1FlA');
});

});

parcelRegister("cxoAD", function(module, exports) {

module.exports = (parcelRequire("hCcZp"))($parcel$resolve("gOGO4")).then(function() {
    return parcelRequire('g8iNN');
});

});

var $6bf4ea2ad047cba5$exports = {};
$parcel$extendImportMap({
    "cqYiL": "CookieBar.b338e7a0.js",
    "5An4N": "FeaturedContent.79b6e8c5.js",
    "ixT6m": "FeaturedContent.0d66c065.js",
    "hoSNJ": "FeaturedContent.936a71c8.css",
    "8xFqm": "VariantPicker.cdcafca6.js",
    "j8ywC": "Product.bec0f69e.js",
    "7JefW": "Product.525d1328.css",
    "5GTpR": "Cart.756fc172.js",
    "gZsuc": "AddOnProduct.7b3261bf.js",
    "etSDY": "MainNav.690a3785.js",
    "3HgTV": "Search.4e9f52d7.js",
    "4sX1A": "ProductGrid.dce030f4.js",
    "kaBKd": "ProductGrid.1ac9229d.css",
    "eFnYd": "ProductItem.ccca79a5.js",
    "3wgN9": "ProductItem.bfd53637.css",
    "gnvdu": "CollectionFilter.5280402a.js",
    "iAlPo": "Modal.e86d73d1.js",
    "loWJC": "ModalOpener.3a5ccaff.js",
    "9tiVx": "Dropdown.3e963266.js",
    "jhsKi": "ProductRecommendations.cc70af5b.js",
    "30o7y": "CopyLink.dc592bb0.js",
    "26zBb": "MasonryGrid.7424a833.js",
    "2g9s5": "OptionsSelector.01895d35.js",
    "gtSJU": "LargeInlineCarousel.6bcb2865.js",
    "j4I4v": "LargeInlineCarousel.84ac439a.css",
    "9Ca07": "ShapesCarousel.562b3d7d.js",
    "futxT": "ShapesCarousel.e7874e01.css",
    "gOGO4": "BackToTop.8fd49266.js"
});


var $gBmLA = parcelRequire("gBmLA");
var $897e38eb0057ba49$exports = {};
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if ($897e38eb0057ba49$exports) $897e38eb0057ba49$exports = lazySizes;
})(typeof window != 'undefined' ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    'use strict';
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: 'lazyload',
            loadedClass: 'lazyloaded',
            loadingClass: 'lazyloading',
            preloadClass: 'lazypreload',
            errorClass: 'lazyerror',
            //strictClass: 'lazystrict',
            autosizesClass: 'lazyautosizes',
            fastLoadedClass: 'ls-is-cached',
            iframeLoadMode: 0,
            srcAttr: 'data-src',
            srcsetAttr: 'data-srcset',
            sizesAttr: 'data-sizes',
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function init() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = 'addEventListener';
    var _getAttribute = 'getAttribute';
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        'load',
        'error',
        'lazyincluded',
        '_lazyloaded'
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function hasClass(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function addClass(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function removeClass(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
    };
    var addRemoveLoadEvents = function addRemoveLoadEvents1(dom, fn, add) {
        var action = add ? _addEventListener : 'removeEventListener';
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent('Event');
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function updatePolyfill(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]('srcset')) el.setAttribute('srcset', full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function getCSS(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function getWidth(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function run() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function rafBatch(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function rAFIt(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function throttle(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function run() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function idleCallback() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function debounce(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function run() {
            timeout = null;
            func();
        };
        var later = function later1() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = 'onscroll' in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function resetPreloading(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function isVisible(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
        };
        var isNestedVisible = function isNestedVisible(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, 'opacity') || 1) > 0;
                if (visible && getCSS(parent, 'overflow') != 'visible') {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function checkElements() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto'))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function switchLoadingClass(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, 'lazyloaded');
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function changeIframeSrc(elem, src) {
            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function handleSources(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) source.setAttribute('media', customMedia);
            if (sourceSrcset) source.setAttribute('srcset', sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute('sizes', sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || '');
                }
                firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName('source'), handleSources);
                if (srcset) elem.setAttribute('srcset', srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ('_lazyCache' in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == 'lazy') isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function unveilElement(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
            var isAuto = sizes == 'auto';
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, 'lazyunveilread').detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function altLoadmodeScrollListner() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function onload1() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener('scroll', altLoadmodeScrollListner, true);
        };
        return {
            _: function _() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);
                addEventListener('scroll', throttledCheckElements, true);
                addEventListener('resize', throttledCheckElements, true);
                addEventListener('pageshow', function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener('hashchange', throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    'focus',
                    'mouseover',
                    'click',
                    'load',
                    'transitionend',
                    'animationend'
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener('load', onload);
                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += 'px';
            elem.setAttribute('sizes', width);
            if (regPicture.test(parent.nodeName || '')) {
                sources = parent.getElementsByTagName('source');
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute('sizes', width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function getSizeElement(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, 'lazybeforesizes', {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function updateElementsSizes() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function _() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener('resize', debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function init1() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});























document.addEventListener('DOMContentLoaded', function() {
    /*
  ----------------
  CREDITS
  ----------------
  */ console.log('%c \nDevelopment by Cold Rice \n \ncold-rice.info \n \n', 'color: grey');
    /*
  ----------------
  VARS
  ----------------
  */ var isLargeQuery = window.matchMedia('(min-width: 1024px)').matches;
    var featuredContentEls = Array.from(document.querySelectorAll('.home-featured-content'));
    var mainSearch = document.querySelector('#predictive-search-container');
    var productGridEls = Array.from(document.querySelectorAll('.product-grid-carousel'));
    var collectionFilterEls = Array.from(document.querySelectorAll('.collection-filters'));
    var isMainProduct = document.querySelector('.main-product');
    var modalOpenerEls = Array.from(document.querySelectorAll('.modal-opener'));
    var modalEls = Array.from(document.querySelectorAll('.def-modal'));
    var dropdownEls = Array.from(document.querySelectorAll('.def-dropdown'));
    var recommendationEls = Array.from(document.querySelectorAll('.product-recommendations'));
    var mainNav = document.querySelector('.main-header');
    var cartSection = document.querySelector('.main-cart-section');
    var copyLinks = Array.from(document.querySelectorAll('.copy-link'));
    var cookieBarEl = document.getElementById('cookie-bar');
    var optionSelectorEls = Array.from(document.querySelectorAll('.options-selector'));
    var largeInlineCarouselEls = Array.from(document.querySelectorAll('.large-inline-carousel'));
    var shapesCarouselEls = Array.from(document.querySelectorAll('.shapes-carousel'));
    var masonryGridEls = Array.from(document.querySelectorAll('.masonry-grid'));
    var backToTopEls = Array.from(document.querySelectorAll('.back-to-top'));
    /*
  ----------------
  COOKIE BAR
  ----------------
  */ // set initial cookie state
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).get('june-cookie-consent') === 'accept') document.body.classList.add('cookies-accepted');
    // initialize cookie bar if applicable
    if (cookieBarEl) (parcelRequire("9Wvn0")).then(function(param) {
        var CookieBar = param.default;
        new CookieBar({
            el: cookieBarEl
        });
    });
    /*
  ----------------
  FACEBOOK TRACK PAGE VIEW
  ----------------
  */ if (document.body.classList.contains('cookies-accepted')) {
        fbq('init', '408190634089291');
        fbq('track', 'PageView');
    }
    /*
  ----------------
  FEATURED CONTENT
  ----------------
  */ if (featuredContentEls.length) (parcelRequire("5TUQh")).then(function(param) {
        var FeaturedContent = param.default;
        featuredContentEls.forEach(function(el) {
            new FeaturedContent({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  MAIN PRODUCT
  ----------------
  */ if (isMainProduct) {
        (parcelRequire("97pEG")).then(function(param) {
            var VariantPicker = param.default;
            window.customElements.define('variant-picker', VariantPicker);
        });
        (parcelRequire("99uCv")).then(function(param) {
            var Product = param.default;
            new Product({
                el: isMainProduct,
                isLargeQuery: isLargeQuery
            });
        });
    }
    /*
  ----------------
  CART
  ----------------
  */ if (cartSection) {
        (parcelRequire("3wkHv")).then(function(param) {
            var Cart = param.default;
            window.customElements.define('cart-section', Cart);
        });
        (parcelRequire("lRD4C")).then(function(param) {
            var AddOnProduct = param.default;
            window.customElements.define('add-on-product', AddOnProduct);
        });
    }
    /*
  ----------------
  MAIN NAV
  ----------------
  */ if (mainNav) (parcelRequire("4MthR")).then(function(param) {
        var MainNav = param.default;
        new MainNav({
            el: mainNav
        });
    });
    /*
  ----------------
  SEARCH
  ----------------
  */ if (mainSearch) (parcelRequire("eDuNa")).then(function(param) {
        var Search = param.default;
        new Search({
            el: mainSearch
        });
    });
    /*
  ----------------
  PRODUCT GRID
  ----------------
  */ if (productGridEls.length) (parcelRequire("6D3tK")).then(function(param) {
        var ProductGrid = param.default;
        productGridEls.forEach(function(el) {
            new ProductGrid({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  PRODUCT ITEM
  ----------------
  */ (parcelRequire("aw1e4")).then(function(param) {
        var ProductItem = param.default;
        window.customElements.define('product-item', ProductItem);
    });
    /*
  ----------------
  COLLECTION FILTER
  ----------------
  */ if (collectionFilterEls.length) (parcelRequire("hwV6k")).then(function(param) {
        var CollectionFilter = param.default;
        collectionFilterEls.forEach(function(el) {
            new CollectionFilter({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  MODAL
  ----------------
  */ if (modalEls.length) (parcelRequire("eysPy")).then(function(param) {
        var Modal = param.default;
        modalEls.forEach(function(el) {
            new Modal({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  MODAL OPENER
  ----------------
  */ if (modalOpenerEls.length) (parcelRequire("lY8wQ")).then(function(param) {
        var ModalOpener = param.default;
        modalOpenerEls.forEach(function(el) {
            new ModalOpener({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  DROPDOWN
  ----------------
  */ if (dropdownEls.length) (parcelRequire("5NvQQ")).then(function(param) {
        var Dropdown = param.default;
        dropdownEls.forEach(function(el) {
            new Dropdown({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  RECOMMENDATIONs
  ----------------
  */ if (recommendationEls.length) (parcelRequire("aga3L")).then(function(param) {
        var ProductRecommendations = param.default;
        recommendationEls.forEach(function(el) {
            new ProductRecommendations({
                el: el,
                isLargeQuery: isLargeQuery
            });
        });
    });
    /*
  ----------------
  COPY LINK
  ----------------
  */ if (copyLinks.length) (parcelRequire("6AmCE")).then(function(param) {
        var CopyLink = param.default;
        copyLinks.forEach(function(el) {
            new CopyLink({
                el: el
            });
        });
    });
    /*
  ----------------
  MASONRY GRID
  ----------------
  */ if (masonryGridEls.length) (parcelRequire("jvLL0")).then(function(param) {
        var MasonryGrid = param.default;
        masonryGridEls.forEach(function(el) {
            new MasonryGrid({
                el: el
            });
        });
    });
    /*
  ----------------
  OPTIONS SELECTOR
  ----------------
  */ if (optionSelectorEls.length) (parcelRequire("gYu3a")).then(function(param) {
        var OptionsSelector = param.default;
        optionSelectorEls.forEach(function(el) {
            new OptionsSelector({
                el: el
            });
        });
    });
    /*
  ----------------
  LARGE INLINE CAROUSEL
  ----------------
  */ if (largeInlineCarouselEls.length) (parcelRequire("42APl")).then(function(param) {
        var LargeInlineCarousel = param.default;
        largeInlineCarouselEls.forEach(function(el) {
            new LargeInlineCarousel({
                el: el
            });
        });
    });
    /*
  ----------------
  SHAPES CAROUSEL
  ----------------
  */ if (shapesCarouselEls.length) (parcelRequire("7Ri5d")).then(function(param) {
        var ShapesCarousel = param.default;
        shapesCarouselEls.forEach(function(el) {
            new ShapesCarousel({
                el: el
            });
        });
    });
    /*
  ----------------
  BACK TO TOP
  ----------------
  */ if (backToTopEls.length) (parcelRequire("cxoAD")).then(function(param) {
        var BackToTop = param.default;
        backToTopEls.forEach(function(el) {
            new BackToTop({
                el: el
            });
        });
    });
    /*
  ----------------
  RESIZE
  ----------------
  */ var resizeTimer = null;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var newIsLargeQuery = window.matchMedia('(min-width: 992px)').matches;
            if (newIsLargeQuery !== isLargeQuery) window.location.reload();
            isLargeQuery = newIsLargeQuery;
        }, 450);
    });
});




})();
//# sourceMappingURL=index.js.map
